import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import { Box, Button, IconButton, InputLabel, TextField, Typography } from "@mui/material";
import Card from "@mui/material/Card";
import InputAdornment from "@mui/material/InputAdornment";
import axios from "axios";
import MDBox from "components/MDBox";
import BasicLayout from "layouts/authentication/components/BasicLayout";
import * as React from "react";
import { useState } from "react";
import { useNavigate } from "react-router-dom";

function Basic() {
  const [showPassword, setShowPassword] = React.useState(false);
  const [userName, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [userNameError, setUserNameError] = useState("");
  const [passwordError, setPasswordError] = useState("");
  const [shrink1, setShrink1] = useState(false);
  const [shrink2, setShrink2] = useState(false);
  const appColor = "#59D6DF";
  const navigate = useNavigate();
  const apiBaseURL = process.env.REACT_APP_API_BASE_URL;

  const handleSubmit = (e) => {
    e.preventDefault();
    if (userName == "") {
      setUserNameError("please enter the username");
    } else if (password == "") {
      setPasswordError("please enter the password");
    } else {
      axios
        .post(`${apiBaseURL}/api/v1/admin/sign-in`, {
          userName,
          password
        })
        .then((res) => {
          const token = res?.data.data.token;
          if (token) {
            localStorage.setItem("token", token);
            navigate("/dashboard");
          }
        })
        .catch((error) => {
          console.log(error, "error");
          if (error?.response?.data?.message == "Invalid Username!!") {
            setUserNameError("Invalid Username!!");
          } else if (error?.response?.data?.message == "Invalid password!!") {
            setPasswordError("Invalid password!!");
          } else {
            setUserNameError("");
            setPasswordError("");
          }
        });
    }
  };

  React.useEffect(() => {
    if (userName != "") {
      setShrink1(true);
    }
    if (password != "") {
      setShrink1(true);
    }
  }, []);

  const handleClickShowPassword = () => setShowPassword((show) => !show);

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  const handleMouseUpPassword = (event) => {
    event.preventDefault();
  };

  return (
    <div>
      <BasicLayout>
        <Card>
          <MDBox textAlign="center" pb={3} py={4}>
            <Box
              component="img"
              sx={{
                height: 100,
                width: "auto",
                alignItems: "center"
              }}
              alt="The house from the offer."
              src={process.env.PUBLIC_URL + "/AppLogo.png"}
            />
          </MDBox>
          <MDBox
            bgColor="white"
            color="white"
            borderRadius="lg"
            // coloredShadow="info"
            mx={2}
            mt={-3}
            p={2}
            mb={1}
            textAlign="center"
          >
            <Typography variant="h4" fontWeight="medium" color="#59D6DF" mt={1}>
              Sign In
            </Typography>
          </MDBox>
          <MDBox pt={4} pb={3} px={3}>
            <form autoComplete="off" onSubmit={handleSubmit}>
              <Box mb={2}>
                <TextField
                  fullWidth
                  label="Username"
                  name="userName"
                  value={userName}
                  autoComplete="off"
                  onChange={(event) => {
                    setUsername(event.target.value);
                    if (event.target.value) {
                      setUserNameError("");
                      setShrink1(true);
                    } else {
                      setUserNameError("please enter the username");
                      setShrink1(false);
                    }
                  }}
                  onFocus={() => setShrink1(true)}
                  onBlur={() => {
                    if (!userName) setShrink1(false);
                  }}
                  onSelect={() => setShrink1(true)}
                  InputLabelProps={{ shrink: shrink1 }}
                  inputProps={{
                    autoComplete: "username",
                    form: {
                      autocomplete: "off"
                    }
                  }}
                />
                <InputLabel sx={{ pt: 1, color: "red" }}>{userNameError}</InputLabel>
              </Box>
              <Box mb={2}>
                <TextField
                  fullWidth
                  label="Password"
                  type={showPassword ? "text" : "password"}
                  name="password"
                  autoComplete="off"
                  value={password}
                  onChange={(event) => {
                    setPassword(event.target.value);
                    if (event.target.value) {
                      setPasswordError("");
                      setShrink2(true);
                    } else {
                      setPasswordError("please enter the password");
                      setShrink2(false);
                    }
                  }}
                  onFocus={() => setShrink2(true)}
                  onBlur={() => {
                    if (!password) setShrink2(false);
                  }}
                  onSelect={() => setShrink1(true)}
                  InputLabelProps={{ shrink: shrink2 }}
                  InputProps={{
                    // <-- This is where the toggle button is added.
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          aria-label="toggle password visibility"
                          onClick={handleClickShowPassword}
                          onMouseDown={handleMouseDownPassword}
                        >
                          {showPassword ? <Visibility /> : <VisibilityOff />}
                        </IconButton>
                      </InputAdornment>
                    )
                  }}
                  inputProps={{
                    autoComplete: "new-password",
                    form: {
                      autocomplete: "off"
                    }
                  }}
                />
                <InputLabel sx={{ pt: 1, color: "red" }}>{passwordError}</InputLabel>
              </Box>
              <Box mt={4} mb={1}>
                <Button
                  variant="contained"
                  type="submit"
                  sx={{
                    backgroundColor: "#000000",
                    color: "#FFFFFF",
                    ":hover": {
                      backgroundColor: "#000000"
                    }
                  }}
                  fullWidth
                >
                  sign in
                </Button>
              </Box>
            </form>
          </MDBox>
        </Card>
      </BasicLayout>
    </div>
  );
}

export default Basic;
